const MIN_VALUE = 0;
const MAX_VALUE_CELSIUS = 100;
const MAX_VALUE = 1000000;

const parameterTable = {
  tableHorizontal: [],
  tableVertical: [
    {
      key: 'dielectricStrength',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dielectric-strength',
      options: {
        maxLength: 12,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 2,
      iecRuleOperator: '>=',
    },
    {
      key: 'neutralizationIndex',
      text: 'fields.engineering.physical-chemical.vertical-parameters.neutralization-index',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '<=',
    },
    {
      key: 'interfacialTension25',
      text: 'fields.engineering.physical-chemical.vertical-parameters.interfacial-tension',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>=',
    },
    {
      key: 'waterContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.water-content',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '<=',
    },
    {
      key: 'waterContent20',
      text: 'fields.engineering.physical-chemical.vertical-parameters.water-content-20',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'dissipationFactor25',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '>',
      textParams: {
        temperature: 25,
      },
    },
    {
      key: 'dissipationFactor90',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '<=',
      textParams: {
        temperature: 90,
      },
    },
    {
      key: 'dissipationFactor100',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '>',
      textParams: {
        temperature: 100,
      },
    },
    {
      key: 'color',
      text: 'fields.engineering.physical-chemical.vertical-parameters.color',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'colorBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.color-before-filling',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'relativeDensityBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.relative-density',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>',
    },
    {
      key: 'containLevelPcbContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.pcb-content',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '<=',
    },
    {
      key: 'contaminatedLevelPcbContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.pcb-content-contaminated',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '<=',
    },
    {
      key: 'dbdsContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dbds-content',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>',
    },
    {
      key: 'passivatorContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.passivator-content',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>=',
    },
    {
      key: 'passivatorDecayRate',
      text: 'fields.engineering.physical-chemical.vertical-parameters.passivator-decay-rate',
      options: {
        maxLength: 12,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 2,
      iecRuleOperator: '<=',
    },
    {
      key: 'dbpcInhibitorContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dbpc-inhibitor-content-percentage',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '>=',
    },
    {
      key: 'dbpcInhibitorContentOriginalPercentage',
      text: 'fields.engineering.physical-chemical.vertical-parameters.percentage-original-dbpc-inhibitor-content',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '>=',
    },
    {
      key: 'originalInhibitorContent',
      text: 'fields.engineering.physical-chemical.vertical-parameters.original-dbpc-inhibitor-content',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
    },
    {
      key: 'totalDissolvedGasesInOil',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dissolved-gases',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'resistivity90',
      text: 'fields.engineering.physical-chemical.vertical-parameters.resistivity',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>=',
      textParams: {
        temperature: 90,
      },
    },
    {
      key: 'resistivity20',
      text: 'fields.engineering.physical-chemical.vertical-parameters.resistivity',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>=',
      textParams: {
        temperature: 20,
      },
    },
    {
      key: 'particlesCount',
      text: 'fields.engineering.physical-chemical.vertical-parameters.particle-count',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '<=',
    },
    {
      key: 'particlesCountBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.particle-count-before-filling',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'particlesCountAfterFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.particle-count-after-filling',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'flashPoint',
      text: 'fields.engineering.physical-chemical.vertical-parameters.flash-point',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '<',
    },
    {
      key: 'flashPointDifferenceInDegrees',
      text: 'fields.engineering.physical-chemical.vertical-parameters.flash-point-degrees-difference',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>=',
    },
    {
      key: 'flashPointDifferenceInPercentage',
      text: 'fields.engineering.physical-chemical.vertical-parameters.flash-point-percent-difference',
      options: {
        maxLength: 5,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 1,
      iecRuleOperator: '<=',
    },
    {
      key: 'rbot',
      text: 'fields.engineering.physical-chemical.vertical-parameters.rbot',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '<',
    },
    {
      key: 'moderatelyHumidInsulationOilSaturationLevel',
      text: 'fields.engineering.physical-chemical.vertical-parameters.oil-saturation-insulation-level-moderately-humid',
      options: {
        maxLength: 5,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 1,
      iecRuleOperator: '<=',
      tooltip: 'fields.physical-chemical-analysis.oil-saturation-tooltip',
    },
    {
      key: 'humidInsulationLevelOilSaturation',
      text: 'fields.engineering.physical-chemical.vertical-parameters.oil-saturation-insulation-level-humid',
      options: {
        maxLength: 5,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 1,
      iecRuleOperator: '<=',
      tooltip: 'fields.physical-chemical-analysis.oil-saturation-tooltip',
    },
    {
      key: 'extremelyHumidInsulationOilSaturationLevel',
      text: 'fields.engineering.physical-chemical.vertical-parameters.oil-saturation-insulation-level-extremely-humid',
      options: {
        maxLength: 5,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 1,
      iecRuleOperator: '<=',
      tooltip: 'fields.physical-chemical-analysis.oil-saturation-tooltip',
    },
    {
      key: 'dielectricStrengthBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dielectric-strength-before-filling',
      options: {
        maxLength: 12,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 2,
      iecRuleOperator: '<',
    },
    {
      key: 'dissipationFactor25BeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor-before-filling',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '>',
      textParams: {
        temperature: 25,
      },
    },
    {
      key: 'dissipationFactor100BeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dissipation-factor-before-filling',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '>',
      textParams: {
        temperature: 100,
      },
    },
    {
      key: 'interfacialTension25BeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.interfacial-tension-before-filling',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '<',
    },
    {
      key: 'neutralizationIndexBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.neutralization-index-before-filling',
      options: {
        maxLength: 13,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 3,
      iecRuleOperator: '>',
    },
    {
      key: 'waterContentBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.water-content-before-filling',
      options: {
        maxLength: 10,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE,
      },
      precision: 1,
      iecRuleOperator: '>',
    },
    {
      key: 'dbpcInhibitorContentBeforeFilling',
      text: 'fields.engineering.physical-chemical.vertical-parameters.dbpc-inhibitor-content-before-filling',
      options: {
        maxLength: 7,
      },
      range: {
        minimum: MIN_VALUE,
        maximum: MAX_VALUE_CELSIUS,
      },
      precision: 3,
      iecRuleOperator: '<',
    },
  ],
};

export default parameterTable;
